module.exports = __webpack_public_path__ + "static/media/ios-integration.0cb318a7.md";